import * as types from 'constants/recursosActionTypes';
import * as services from 'services/recursos.service';

export const getImageOrVideoResource = (urlResource) => async (dispatch) => {
  dispatch({ type: types.GET_RECURSOS_LOADING });
  try {
    const request = {
      urlRecurso: `/${urlResource}`
    };
    const { data } = await services.getRecurso(request);
    const payload = data;
    dispatch({ type: types.GET_RECURSOS_SUCCESS, payload });
    return { success: true, response: payload.archivo };
  } catch (error) {
    dispatch({ type: types.GET_RECURSOS_FAILURE, error });
    return { success: false, response: error };
  }
};
